import React from 'react';
import { Layout } from '../components/layout/Layout';
import { PageHero, FAQSection, CTASection } from '../components/shared';
import { pageHeroImages, faqData } from '../data/mock';

export const FAQPage = () => {
  return (
    <Layout>
      <PageHero
        title="Fragen & Antworten (FAQ)"
        subtitle="Wir haben die häufigsten Fragen unserer Patienten für Sie zusammengefasst."
        backgroundImage={pageHeroImages.faq}
        showCTA={false}
      />

      <FAQSection
        title="Häufige Fragen"
        faqs={faqData}
      />

      <CTASection
        title="Ihre Frage wurde nicht beantwortet?"
        subtitle="Rufen Sie uns an oder kommen Sie vorbei – wir helfen Ihnen gerne weiter."
        buttonText="Termin für Beratung buchen"
      />
    </Layout>
  );
};

export default FAQPage;
